export default __webpack_public_path__ + "static/media/grid_1__12.abfa9534.jpg";